import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import { Button } from '@material-ui/core';

class Camion extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'camion/one', saveUrl: false, backUrl: false },
      new Form([
        Form.Field('file', 'file', 'Subir Arcvhivo XLSX', '', [Validators.required], 12, [], [], [], false, false, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'),
      ], ['Guardar'], 'Cancelacion de Facturas'), this.formData
    )
  }

  onSubmit = async (i, vals) => {
    try {
      this.setState({ loading: true });
      let form = new FormData();
      form.append('file', vals.file[0]);
      setTimeout(() => {
        this.props.history.push('/Ventas/CancelacionesFacturas')
      }, 7000);
      let res = await Http.post(`proceso-cancelacion/facturacion-cancelar`, form, true, 'arraybuffer');
      if (res) {
        const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'Reporte.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.log(error)
    }
    this.setState({ loading: false });
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(Camion)
